import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DataTableConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DeviceCarouselV1Component } from '../device-donut-carousel-v1/device-donut-carousel-v1.component';

export interface DeviceInterface {
	impressions: number;
	clicks: number;
	clickThroughRate: number;
	device: number;
	cost: number;
	viewThroughs: number;
	viewThroughRate: number;
}

@Component({
	selector: 'app-devices-v4',
	styleUrls: ['./devices-v4.component.css'],
	templateUrl: './devices-v4.component.html'
})
export class DevicesV4Component extends DeviceCarouselV1Component implements OnInit, AfterViewInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() groupby: string;
	@Input() fields: any;
	@Input() colorsconfig: any;
	@Input() downloadconfig: any;
	@Input() datatableconfig;
	@Input() downloadcsvcolumns: any;
	@Input() legend: any;

	public devicedatatableconfig: DataTableConfig = {} as DataTableConfig;
	public downloadCSVColumns: any;
	public selectedLegendName: string = 'impressions';
	public selectedGraphData: any;
	public isCtv: boolean;
	public isAudio: boolean;
	public youtubeViewsPermission: boolean = false;
	public youtubeViewsPermissionCheck: object = { permission: { flags: ['hasYoutubeViews'] } };
	public isPreroll: boolean = false;

	@ViewChild('chartcontainer', { read: ElementRef }) chartContainer: ElementRef;

	public chartObjConfig = {
		addSeriesNameToLables: true,
		dataLabelsDistance: -80,
		innerSize: '0',
		lineBreak: true,
		margin: [10, 10, 50, 10],
		size: '50%',
		startAngle: 90,
		svgHeight: 0,
		svgWidth: 0,
		verticalAlign: 'bottom'
	};
	public deviceData;
	protected navigateSlideSubscription;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.navigateSlideSubscription = EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).subscribe((response) => {
			if (response.widget.toLowerCase() === 'devices') {
				this.selectedLegendName = 'impressions';
				this.reload();
			} else if (
				response.widget.toLowerCase() === 'browsers and devices' &&
				this.analyticsDataModel.getCurrentPath() === PATHS.Email
			) {
				this.selectedLegendName = 'clicks';
				this.reload();
			}
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.selectedLegendName = 'impressions';
		this.devicedatatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.legend = this.legend ? JSON.parse(decodeURI(this.legend)) : [];
		if (this.legend) {
			this.legend = _.filter(this.legend, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.isCtv = this.analyticsDataModel.getCurrentPath() === PATHS.CTV;
		this.isAudio = this.analyticsDataModel.getCurrentPath() === PATHS.RADIO;
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
		this.isPreroll = this.analyticsDataModel.getCurrentPath() === PATHS.PREROLL;
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		this.navigateSlideSubscription.unsubscribe();
	}

	reload(): void {
		this.chartObjConfig.svgWidth = jQuery(this.chartContainer.nativeElement).width() / 2;
		this.chartObjConfig.svgHeight = jQuery(this.chartContainer.nativeElement).height() - 80;
		this.setGraphData(this.deviceChartObjArray);
	}

	setGraphData(chartData: any): void {
		for (const deviceData of chartData) {
			deviceData.chartObjConfig = { ...this.chartObjConfig };
			deviceData.chartObjConfig.seriesName = deviceData.seriesName;
		}
		this.deviceChartObjArray = chartData;
		this.processSelectedLegendItem(this.selectedLegendName);
	}

	processResponseData(responseData: any): void {
		this.deviceData = this.mapDeviceReponseDataToModel(responseData);
		const deviceChartDataObjArray = this.buildDeviceChartCollatorByFields(this.deviceData);
		this.setGraphData(deviceChartDataObjArray);
	}

	buildDeviceChartCollatorByFields(deviceData: any): any[] {
		const fieldChartArray: any[] = [];
		for (const field of this.fields) {
			const chartObjArray: any[] = [];
			const chartData: any = {};
			const seletedLegend = this.legend.filter((legendObj) => legendObj.value === field);
			for (let i = 0; i < deviceData.length; i++) {
				const chartObj: any = {};
				chartObj.name = deviceData[i].device;
				chartObj.color = this.getColorFromColorConfig(i, 1);
				chartObj.y = deviceData[i][field];
				chartObjArray.push(chartObj);
			}
			chartData.chartObj = chartObjArray;
			chartData.seriesName = seletedLegend && seletedLegend[0] ? seletedLegend[0].displayName : field;
			chartData.seriesMetric = field;
			chartData.seriesHasData = this.checkFor(field);
			fieldChartArray.push(chartData);
		}
		return fieldChartArray;
	}

	processSelectedLegendItem(legendItem: any): void {
		const filteredGraph = this.deviceChartObjArray.filter(
			(chartObj) => chartObj.seriesMetric.toLowerCase() === legendItem.toLowerCase()
		);
		this.selectedLegendName = legendItem;
		this.selectedGraphData = filteredGraph && filteredGraph[0] ? filteredGraph[0] : {};
	}

	onResize(event: any): void {
		this.reload();
	}

	checkFor(field: any): boolean {
		const arr = _.compact(_.pluck(this.deviceData, field));
		if (arr.length > 0) {
			return true;
		}
		return false;
	}

	downloadCsv(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.devicedatatableconfig.csvQueryKey != undefined ? this.devicedatatableconfig.csvQueryKey : this.key,
			this.devicedatatableconfig.downloadFileName,
			this.downloadCSVColumns
		);
	}
}
